import jss from "jss";
import React, { createContext, useContext, useEffect, useState, } from "react";
import { ethInstance as ethereumConnection } from "./ethereum";
import preset from "jss-preset-default";
import { DisconnectWallet } from ".";
jss.setup(preset());
const styles = {
    backdrop: {
        position: "fixed",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        background: "rgba(0,0,0,0.2)",
        zIndex: 999,
    },
    modal: {
        background: "#ffffff",
        borderRadius: "10px",
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1000,
        maxWidth: "100%",
    },
    listButton: {
        borderRadius: "20px",
        backgroundColor: "#ffffff",
        border: "1px solid #d1d5da",
        margin: "5px 0",
        padding: "7px 100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            border: "1px solid #000000",
            cursor: "pointer",
        },
    },
    header: {
        color: "#000000",
        marginBottom: 15,
        padding: "0 45px 15px",
        borderBottom: "1px solid #d1d5da",
    },
    icon: {
        width: 28,
        height: 28,
        verticalAlign: "bottom",
        marginRight: "5px",
    },
    button: {
        border: "1px solid #45b8ff",
        fontSize: 16,
        fontWeight: 600,
        color: "#45b8ff",
        fontFamily: "Work Sans",
        width: 170,
        backgroundColor: "transparent",
        borderRadius: 0,
        padding: "0 24px",
        height: 46,
        "&:hover": {
            color: "#ffffff",
            borderColor: "#ffffff",
            cursor: "pointer",
        },
    },
    addressContainer: {
        display: "flex",
        alignItems: "center",
        fontFamily: "Work Sans",
        fontSize: 16,
        fontWeight: 500,
        color: "#efefef",
    },
    walletIcon: {
        width: 18,
        height: 18,
        marginRight: 7,
        backgroundImage: "radial-gradient(circle at 50% 50%, var(--white), #ff931d 71%)",
    },
};
const { classes } = jss.createStyleSheet(styles).attach();
const ConnectWalletContext = createContext({});
const Backdrop = ({ onClick, className, }) => React.createElement("div", { onClick: onClick, className: className || classes.backdrop });
const Modal = ({ children, className }) => {
    return React.createElement("div", { className: className }, children);
};
const ProvidersList = ({ listButtonClassName, iconClassName }) => {
    const ctx = useContext(ConnectWalletContext);
    const providers = ctx.ethereumConnection.getWalletProviders();
    if (providers.length === 1) {
        ctx.ethereumConnection.setWalletProvider(providers[0]);
        ctx.closeModal();
    }
    return (React.createElement("div", { style: {
            display: "flex",
            flexDirection: "column",
            padding: "0 45px 30px",
        } }, providers.map((provider) => (React.createElement(ProviderButton, { key: provider.id, provider: provider, className: listButtonClassName, iconClassName: iconClassName })))));
};
const ProviderButton = ({ provider, className, iconClassName, }) => {
    const ctx = useContext(ConnectWalletContext);
    const handleClick = async (provider) => {
        await ctx.ethereumConnection.setWalletProvider(provider);
        ctx.closeModal();
        ctx.onConnect();
    };
    return (React.createElement("button", { key: provider.id, className: className, onClick: () => handleClick(provider) },
        provider.logo ? (React.createElement("img", { className: iconClassName, src: provider.logo })) : null,
        React.createElement("span", null, provider.name)));
};
const ConnectWalletButton = ({ onClick, className, walletIconClassName, addressContainerClassName, DisconnectWalletComponent, }) => {
    const shortenWalletAddress = (address) => {
        return address ? `${address.substr(0, 6)}...${address.substr(-4)}` : "";
    };
    const ctx = useContext(ConnectWalletContext);
    const additionalButtonParams = {};
    if (className)
        additionalButtonParams.className = className;
    return (React.createElement(React.Fragment, null,
        ctx.ethereumConnection.currentAccount && (React.createElement("div", { className: addressContainerClassName },
            React.createElement("div", { className: walletIconClassName }),
            shortenWalletAddress(ctx.ethereumConnection.currentAccount),
            React.createElement(DisconnectWalletComponent, null))),
        !ctx.ethereumConnection.currentAccount && (React.createElement("button", { onClick: onClick, ...additionalButtonParams }, "connect wallet"))));
};
const ConnectWallet = ({ className, listButtonClassName, containerClassName, headerClassName, iconClassName, backdropClassName, walletIconClassName, addressContainerClassName, onConnect = () => { }, }) => {
    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const ContextState = {
        ethereumConnection,
        closeModal,
        onConnect,
    };
    useEffect(() => {
        document.addEventListener("account_changed", onConnect);
        return () => {
            document.removeEventListener("account_changed", onConnect);
        };
    }, []);
    return (React.createElement(ConnectWalletContext.Provider, { value: ContextState },
        show && (React.createElement(React.Fragment, null,
            React.createElement(Backdrop, { onClick: () => closeModal(), className: backdropClassName || classes.backdrop }),
            React.createElement(Modal, { className: containerClassName || classes.modal },
                React.createElement("h3", { className: headerClassName || classes.header }, "Connect wallet"),
                React.createElement(ProvidersList, { listButtonClassName: listButtonClassName || classes.listButton, iconClassName: iconClassName || classes.icon })))),
        React.createElement(ConnectWalletButton, { className: className || classes.button, walletIconClassName: walletIconClassName || classes.walletIcon, addressContainerClassName: addressContainerClassName || classes.addressContainer, DisconnectWalletComponent: DisconnectWallet, onClick: () => setShow(true) })));
};
export default ConnectWallet;
